<template>
	<NavigationMenu
		v-model="currentMenuValue"
		disable-click-trigger
		:delay-duration="200"
		:skip-delay-duration="300"
		class="h-full"
		viewport-class="bg-primary"
	>
		<slot name="logo" />
		<NavigationMenuList class="h-[80px]" orientation="horizontal">
			<NavigationMenuItem value="buy" class="h-full">
				<NavigationMenuTrigger
					class="h-full text-base font-normal leading-[24px] tracking-wide"
					@click="trackHeader.handleEventHeaderClick('Comprar')"
				>
					Comprar
				</NavigationMenuTrigger>
				<NavigationMenuContent>
					<ul
						class="grid min-h-[359px] bg-primary md:w-[400px]"
						:class="[
							selectedCity
								? 'grid-cols-3 lg:w-[747px] xl:w-[1077px]'
								: 'grid-cols-2 lg:w-[498px] xl:w-[715px]'
						]"
					>
						<li class="row-span-3 border-r border-primary-light-4 px-6 py-8">
							<PortalHeaderNavSectionDefault
								:nav-options="buyOptionsWithNav"
								as-child
							/>
						</li>

						<li
							class="row-span-3 border-r border-primary-light-4 py-8 pl-[32px]"
						>
							<PortalHeaderNavSectionCities
								v-model:selected-city="selectedCity"
								:cities="cities"
								as-child
							/>
						</li>
						<li v-if="selectedCity" class="row-span-3 bg-primary-light-4 p-8">
							<PortalHeaderNavSectionCityRegion
								v-model:selected-city="selectedCity"
								as-child
							/>
						</li>
					</ul>
				</NavigationMenuContent>
			</NavigationMenuItem>
			<NavigationMenuItem value="sell" class="h-full">
				<NavigationMenuTrigger
					class="h-full text-base font-normal leading-[24px] tracking-wide"
					@click="trackHeader.handleEventHeaderClick('Vender')"
				>
					Vender
				</NavigationMenuTrigger>
				<NavigationMenuContent>
					<ul class="grid min-h-[208px] w-[360px] bg-primary">
						<li class="row-span-3 border-r border-primary-light-4 px-6 py-8">
							<PortalHeaderNavSectionDefault
								:nav-options="sellOptions"
								as-child
							/>
						</li>
					</ul>
				</NavigationMenuContent>
			</NavigationMenuItem>
		</NavigationMenuList>
	</NavigationMenu>
</template>

<script setup lang="ts">
import type { City } from './index';

import {
	NavigationMenu,
	NavigationMenuContent,
	NavigationMenuItem,
	NavigationMenuList,
	NavigationMenuTrigger
} from '@/components/ui/navigation-menu';
import { useEvents } from '~/composables/events/useEvents';
import { useShortsNavigation } from '~/composables/shorts';
import { useFeatureFlags } from '~/composables/useFeatureFlags';
import { useNavigationStore } from '~/store/navigationStore';
import { resolveBuyOptionsWithFlags } from '~/utils/index';

import { getCities, highlightBuyOptions, sellOptions } from './index';

const { trackHeader } = useEvents();
const { navigateToShortsWithContext } = useShortsNavigation();
const { ft_shorts_access_points, ft_temp_shorts_new_menu } = useFeatureFlags();
const navigationStore = useNavigationStore();

defineOptions({
	// TODO: Escobar falou que adicionu esse inheritAttrs: false porque estava dando warning no console. mas acabou quebrando o funcionamento do menu. Então estou comentando ele por enquanto.
	// inheritAttrs: false
});

const currentMenuValue = ref<string>('');

const cities = getCities();

const selectedCity = ref<City | null>(cities[0] ?? null);

const buyOptionsWithNav = computed(() =>
	resolveBuyOptionsWithFlags(
		highlightBuyOptions,
		{
			shortsAccessPoints: ft_shorts_access_points,
			shortsNewMenuBadge: ft_temp_shorts_new_menu
		},
		navigateToShortsWithContext
	)
);

watch(currentMenuValue, (value: string) => {
	// Reset selected city when buy menu closes
	if (value !== 'buy') {
		selectedCity.value = cities[0] ?? null;
	}

	// Update navigation store
	const isAnyMenuOpen = value === 'buy' || value === 'sell';
	navigationStore.setIsNavigationMenuOpen(isAnyMenuOpen);
});
</script>
